/*
 * @Descripttion:
 * @Author: cb4786
 * @Date: 2023-08-18 14:51:11
 * @LastEditors: cb4786
 * @LastEditTime: 2023-08-18 17:28:56
 */
import { AllowAccountRes } from '../../../../api/orderManage'
import { SearchItemFilter } from '../../../../components/SearchFilter'
import { PaginationOption } from '../../../../global'
import { message } from 'antd'

interface State {
  checkedKeys: string[]
  checkedData: AllowAccountRes[]
  searchParam: SearchItemFilter
  loading: boolean
  pagination: PaginationOption
  orderData: AllowAccountRes[]
}

type ActionType =
  | 'setCheckedKeys'
  | 'setCheckedData'
  | 'setSearchParam'
  | 'setLoading'
  | 'setPagination'
  | 'setOrderData'
  | 'resetState'

interface Action {
  type: ActionType
  payload?: any
}

export const initialState: State = {
  checkedKeys: [],
  checkedData: [],
  searchParam: {},
  loading: false,
  pagination: {
    totalCount: 0,
    pageNo: 1,
    pageSize: 10,
  },
  orderData: [],
}

const reducer = (state: State = initialState, action: Action): State => {
  const newState = { ...state }
  switch (action.type) {
    case 'setCheckedKeys':
      newState.checkedKeys = action.payload
      return newState
    case 'setCheckedData':
      newState.checkedData = action.payload
      return newState
    case 'setSearchParam':
      newState.searchParam = action.payload
      return newState
    case 'setLoading':
      newState.loading = action.payload
      return newState
    case 'setPagination':
      newState.pagination = action.payload
      return newState
    case 'setOrderData':
      newState.orderData = action.payload
      return newState
    case 'resetState':
      return initialState
    default:
      message.error('not match actions')
      throw new Error('not match actions')
  }
}

export default reducer

export const setCheckedKeysAction = (params: string[]): Action => ({
  type: 'setCheckedKeys',
  payload: params,
})

export const setCheckedDataAction = (params: AllowAccountRes[]): Action => ({
  type: 'setCheckedData',
  payload: params,
})

export const setSearchParamAction = (val: SearchItemFilter): Action => ({
  type: 'setSearchParam',
  payload: val,
})

export const setLoadingAction = (val: boolean): Action => ({
  type: 'setLoading',
  payload: val,
})

export const setPaginationAction = (val: PaginationOption): Action => ({
  type: 'setPagination',
  payload: val,
})

export const setOrderDataAction = (val: AllowAccountRes[]): Action => ({
  type: 'setOrderData',
  payload: val,
})

export const resetStateAction = (): Action => ({
  type: 'resetState',
})
/*
 * @Descripttion:
 * @Author: cb4786
 * @Date: 2023-08-18 14:51:11
 * @LastEditors: cb4786
 * @LastEditTime: 2023-08-18 17:28:56
 */
import { AllowAccountRes } from '../../../../api/orderManage'
import { SearchItemFilter } from '../../../../components/SearchFilter'
import { PaginationOption } from '../../../../global'
import { message } from 'antd'

interface State {
  checkedKeys: string[]
  checkedData: AllowAccountRes[]
  searchParam: SearchItemFilter
  loading: boolean
  pagination: PaginationOption
  orderData: AllowAccountRes[]
}

type ActionType =
  | 'setCheckedKeys'
  | 'setCheckedData'
  | 'setSearchParam'
  | 'setLoading'
  | 'setPagination'
  | 'setOrderData'
  | 'resetState'

interface Action {
  type: ActionType
  payload?: any
}

export const initialState: State = {
  checkedKeys: [],
  checkedData: [],
  searchParam: {},
  loading: false,
  pagination: {
    totalCount: 0,
    pageNo: 1,
    pageSize: 10,
  },
  orderData: [],
}

const reducer = (state: State = initialState, action: Action): State => {
  const newState = { ...state }
  switch (action.type) {
    case 'setCheckedKeys':
      newState.checkedKeys = action.payload
      return newState
    case 'setCheckedData':
      newState.checkedData = action.payload
      return newState
    case 'setSearchParam':
      newState.searchParam = action.payload
      return newState
    case 'setLoading':
      newState.loading = action.payload
      return newState
    case 'setPagination':
      newState.pagination = action.payload
      return newState
    case 'setOrderData':
      newState.orderData = action.payload
      return newState
    case 'resetState':
      return initialState
    default:
      message.error('not match actions')
      throw new Error('not match actions')
  }
}

export default reducer

export const setCheckedKeysAction = (params: string[]): Action => ({
  type: 'setCheckedKeys',
  payload: params,
})

export const setCheckedDataAction = (params: AllowAccountRes[]): Action => ({
  type: 'setCheckedData',
  payload: params,
})

export const setSearchParamAction = (val: SearchItemFilter): Action => ({
  type: 'setSearchParam',
  payload: val,
})

export const setLoadingAction = (val: boolean): Action => ({
  type: 'setLoading',
  payload: val,
})

export const setPaginationAction = (val: PaginationOption): Action => ({
  type: 'setPagination',
  payload: val,
})

export const setOrderDataAction = (val: AllowAccountRes[]): Action => ({
  type: 'setOrderData',
  payload: val,
})

export const resetStateAction = (): Action => ({
  type: 'resetState',
})
